/* Fit voucher text into its box, shared by the renderer (backend) and the design editor.
   Canonical copy: voucher-backend/src/utils/voucher_html/static/fit-text.js
   Mirror:         voucher-dashboard/src/app/views/voucher-design-editor/shared/fit-text.ts
   Keep the logic identical: the set font size is the maximum; the font shrinks
   until the text fits its box. Nothing is ever cut: a voucher must show its whole
   code, amount and message, so a box too small for its text prints it smaller. */

const MIN_PT = 1; // only a guard against endless loops
const PX_PER_PT = 96 / 72;

function fits(box: HTMLElement): boolean {
  return box.scrollWidth <= box.clientWidth + 0.5 && box.scrollHeight <= box.clientHeight + 0.5;
}

/** Shrink one `.ve-text` / `.ve-multiline` box until its text fits; nothing is ever cut. */
export function fitVoucherTextBox(box: HTMLElement): void {
  const inner = box.firstElementChild as HTMLElement | null;
  if (!inner) return;
  let size = parseFloat(getComputedStyle(box).fontSize);
  const min = MIN_PT * PX_PER_PT;
  while (!fits(box) && size > min) {
    size = Math.max(min, size - 0.5);
    box.style.fontSize = size + 'px';
  }
}

/** Fit every text box below `scope` (the whole document by default). */
export function fitVoucherText(scope: ParentNode = document): void {
  const boxes = scope.querySelectorAll<HTMLElement>('.ve-text, .ve-multiline');
  for (let i = 0; i < boxes.length; i++) fitVoucherTextBox(boxes[i]);
}
